(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zustand-flip-full"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-zustands-flip-full]';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initialize = (section) => {
      if (!section || section.dataset.zffReady === 'true') return;
      section.dataset.zffReady = 'true';

      const track = section.querySelector('[data-zff-track]');
      const cards = Array.from(section.querySelectorAll('[data-zff-card]'));
      const controls = section.querySelector('[data-zff-controls]');
      const previous = section.querySelector('[data-zff-previous]');
      const next = section.querySelector('[data-zff-next]');
      const counter = section.querySelector('[data-zff-counter]');
      let suppressFlipUntil = 0;

      cards.forEach((card) => {
        const front = card.querySelector('[data-zff-front]');
        const back = card.querySelector('[data-zff-back]');
        const triggers = Array.from(card.querySelectorAll('[data-zff-flip]'));
        const frontTrigger = triggers[0];
        const backTrigger = triggers[1];

        const setFlipped = (flipped) => {
          const sourceTrigger = flipped ? frontTrigger : backTrigger;
          const focusTarget = flipped ? backTrigger : frontTrigger;
          const moveFocus = document.activeElement === sourceTrigger;
          card.classList.toggle('is-flipped', flipped);
          frontTrigger.setAttribute('aria-expanded', flipped ? 'true' : 'false');
          frontTrigger.tabIndex = flipped ? -1 : 0;
          backTrigger.tabIndex = flipped ? 0 : -1;
          if (moveFocus) focusTarget.focus({ preventScroll: true });
          front.setAttribute('aria-hidden', flipped ? 'true' : 'false');
          back.setAttribute('aria-hidden', flipped ? 'false' : 'true');
        };

        frontTrigger.addEventListener('click', () => {
          if (performance.now() >= suppressFlipUntil) setFlipped(true);
        });
        backTrigger.addEventListener('click', () => {
          if (performance.now() >= suppressFlipUntil) setFlipped(false);
        });
      });

      if (!track || cards.length === 0) return;

      let frame;

      const currentIndex = () => {
        const left = track.scrollLeft;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (maxScroll > 1 && left >= maxScroll - 2) return cards.length - 1;
        let nearest = 0;
        let distance = Number.POSITIVE_INFINITY;

        cards.forEach((card, index) => {
          const cardLeft = card.offsetLeft - track.offsetLeft;
          const nextDistance = Math.abs(cardLeft - left);
          if (nextDistance < distance) {
            distance = nextDistance;
            nearest = index;
          }
        });

        return nearest;
      };

      const updateControls = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const overflows = maxScroll > 1;
        const index = currentIndex();
        if (controls) controls.hidden = !overflows;
        if (counter) counter.textContent = `${index + 1} / ${cards.length}`;
        if (previous) previous.disabled = !overflows || track.scrollLeft <= 1;
        if (next) next.disabled = !overflows || track.scrollLeft >= maxScroll - 2;
      };

      const move = (direction) => {
        const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const step = cards[0].offsetWidth + gap;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const targetLeft = Math.max(0, Math.min(maxScroll, track.scrollLeft + direction * step));
        track.scrollTo({ left: targetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };

      if (previous) previous.addEventListener('click', () => move(-1));
      if (next) next.addEventListener('click', () => move(1));

      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          move(-1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          move(1);
        }
      });

      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(updateControls);
      }, { passive: true });

      let pointerDown = false;
      let pointerId;
      let dragStartX = 0;
      let dragStartScroll = 0;
      let didDrag = false;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointerDown = true;
        pointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        didDrag = false;
      });

      track.addEventListener('pointermove', (event) => {
        if (!pointerDown || event.pointerId !== pointerId) return;
        const distance = event.clientX - dragStartX;
        if (!didDrag && Math.abs(distance) < 6) return;
        if (!didDrag) {
          didDrag = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(pointerId);
        }
        event.preventDefault();
        track.scrollLeft = dragStartScroll - distance;
      });

      const finishDrag = (event) => {
        if (!pointerDown || event.pointerId !== pointerId) return;
        if (didDrag) suppressFlipUntil = performance.now() + 250;
        pointerDown = false;
        track.classList.remove('is-dragging');
      };

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);

      window.addEventListener('resize', updateControls, { passive: true });
      window.requestAnimationFrame(updateControls);
    };

    const initializeAll = (root = document) => {
      if (root.matches && root.matches(selector)) initialize(root);
      root.querySelectorAll(selector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
